






























































import { Component, Vue, Watch } from "vue-property-decorator";
import { nonZeroNumberOnlyRules } from "@/forms/validation/numbers";
import SplitRow from "./SplitRow164.vue";
import { getBlankSplitRow } from "./splitRow.interface";
import { PackageBuiltEvent } from "./packageBuilt.interface";

@Component<GuidedCustom164>({
  components: {
    SplitRow
  }
})
export default class GuidedCustom164 extends Vue {
  price = 0;
  valuePrint = getBlankSplitRow("Print");
  valueVideo = getBlankSplitRow("Video");
  valueMagazines = getBlankSplitRow("Magazines");
  valueDigital = getBlankSplitRow("Digital");
  valueOther = getBlankSplitRow("Other");

  get formatter() {
    if (window && window.Intl) {
      return window.Intl.NumberFormat("au-AU", {
        style: "currency",
        currency: "AUD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
    }
    return null;
  }

  get nonZeroNumberOnlyRules() {
    return nonZeroNumberOnlyRules;
  }

  get rateCardValue() {
    return (
      this.valuePrint.casualRateValue +
      this.valueVideo.casualRateValue +
      this.valueMagazines.casualRateValue +
      this.valueDigital.casualRateValue +
      this.valueOther.casualRateValue
    );
  }

  get rateCardValueFormatted() {
    if (!this.rateCardValue) return "";
    return this.formatter?.format(this.rateCardValue);
  }

  get nettEffectiveDiscount() {
    return 100 * (1 - this.price / this.rateCardValue);
  }

  get nettEffectiveDiscountFormatted() {
    return `${this.nettEffectiveDiscount.toFixed(1)}%`;
  }

  get priceFormatted() {
    if (!this.price) return "";
    return this.formatter?.format(this.price);
  }

  get packageValue() {
    let multiplier = 1.5;
    if (this.price < 100e3) multiplier = 1.2;
    else if (this.price < 150e3) multiplier = 1.3;
    else if (this.price < 200e3) multiplier = 1.4;
    return multiplier * this.price;
  }

  get packageValueFormatted() {
    return this.formatter?.format(this.packageValue) || "";
  }

  get valueToRealRatio() {
    return this.packageValue / this.price;
  }

  get assignmentTotalNumber() {
    return (
      this.valuePrint.value +
      this.valueVideo.value +
      this.valueMagazines.value +
      this.valueDigital.value +
      this.valueOther.value
    );
  }

  get assignmentTotal() {
    return this.formatter?.format(this.assignmentTotalNumber);
  }

  get unassignedAmount() {
    return this.formatter?.format(
      this.packageValue - this.assignmentTotalNumber
    );
  }

  get isFullyAssigned() {
    return this.price > 0 && this.assignmentTotalNumber === this.packageValue;
  }

  get isOver() {
    return this.assignmentTotalNumber > this.packageValue;
  }

  // get signOnBonusOptions() {
  //   return [
  //     {
  //       value: true,
  //       text: "Y"
  //     },
  //     { value: false, text: "N" }
  //   ];
  // }

  get predefinedPriceOptions() {
    return [
      { value: 0, text: "-" },
      { value: 25e3, text: "25,000" },
      { value: 50e3, text: "50,000" },
      { value: 100e3, text: "100,000" },
      { value: 150e3, text: "150,000" },
      { value: 200e3, text: "200,000" }
    ];
  }

  onPriceSelect(value: string) {
    this.price = parseInt(value);
  }

  get addedValue() {
    if (!this.rateCardValueFormatted) return 0;
    return this.rateCardValue - this.price;
  }

  get addedValueFormatted() {
    if (!this.addedValue) return "";
    return this.formatter?.format(this.addedValue);
  }

  @Watch("isFullyAssigned")
  @Watch("valuePrint")
  @Watch("valueVideo")
  @Watch("valueMagazines")
  @Watch("valueDigital")
  @Watch("valueOther")
  onIsFullyAssigned() {
    if (!this.isFullyAssigned) return;
    const parts: string[] = [
      `News Boost Now campaign with a Total Investment of ${this.priceFormatted}`,
      ` ${this.addedValueFormatted} Added value to be utilized across campaign period.`,
      "\n",
      "Client discount to be:"
    ];
    [
      this.valuePrint,
      this.valueVideo,
      this.valueMagazines,
      this.valueDigital,
      this.valueOther
    ].forEach(({ value, effectiveDiscount, product }) => {
      if (!value) return;
      parts.push(`${product}: ${effectiveDiscount}`);
    });
    const p: PackageBuiltEvent = {
      price: this.price,
      description: parts.join("\n")
    };
    this.$emit("change", p);
  }
}
